import { StimEfficiencyBase } from './base/stim-efficiency-base';

export class StimEfficiency extends StimEfficiencyBase { }